export const integrations = [
  {
    illustration: 'centralize-icon',
    headText: 'Centralize as informações',
    bodyText:
      'Gerencie o financeiro interno e externo da sua imobiliária, tudo em um só lugar, facilitando seu dia a dia.'
  },
  {
    illustration: 'diminua-icon',
    headText: 'Diminua a inadimplência',
    bodyText:
      'Receba pela primeira vez no mercado o aluguel via cartão de crédito com tarifa fixa, sem maquininha e diminua a inadimplência imobiliária.'
  },
  {
    illustration: 'ofereca-icon',
    headText: 'Ofereça novas soluções',
    bodyText:
      'Tenha acesso aos aplicativos Owli e Owli Vistoriador e melhore a experiência dos seus clientes, sem pagar nada a mais por isso.'
  },
  {
    illustration: 'otimize-icon',
    headText: 'Otimize sua produtividade',
    bodyText:
      'Automatize o repasse dos seus proprietários e otimize a produtividade da sua equipe, que poderá focar em outras atividades.'
  }
]
